export default "__VITE_ASSET__DklBdhlN__"